"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import { RenderFocusedImage, FocalPointImageProps } from "./FocusedImageMethods";
import type { JSX } from "react";
export const FocusedImage = props => {
  const $ = _c(4);
  let t0;
  if ($[0] !== props) {
    t0 = RenderFocusedImage(props);
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <React.Fragment>{t0}</React.Fragment>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};